import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import MaskedTextBoxProps from './MaskedTextBoxProps'


export default {
    props: MaskedTextBoxProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoMaskedTextBox(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', that.$refs.valueInput.value)
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMaskedTextBox()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoMaskedTextBox/KendoMaskedTextBoxMixin.js